module.exports = __webpack_public_path__ + "static/openingsdansen-c7939f8a315d77c3fcf5d384fe35fbf7.jpg";